var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vote-box" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center", align: "middle" } },
        [
          _c(
            "el-col",
            { attrs: { span: 18 } },
            [
              _c("el-progress", {
                attrs: {
                  percentage: _vm.percentage,
                  "show-text": _vm.type === "line",
                },
              }),
            ],
            1
          ),
          _c("el-col", { attrs: { span: 6 } }, [
            _vm._v(" " + _vm._s(_vm.quantity) + "票 "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }